<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :append-to-body="true"
    width="480px"
    :before-close="handleClose"
    :destroy-on-close="true"
    @open="handleOpen"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      label-position="left"
      ref="ruleFormRef"
      label-width="80px"
      class="demo-ruleForm"
    >
      <el-form-item label="部门名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          maxlength="50"
          type="text"
          placeholder="请输入"
          show-word-limit
        ></el-input>
      </el-form-item>
      <DeptSelector
        v-model="ruleForm.pid"
        label="所属部门"
        prop="pid"
        :isAll="true"
        v-show="!isSubDept"
        :multiple="false"
      />
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script setup>
import { reactive, ref, computed } from 'vue'
import { addDept, editDept } from '@/api/domain/organize'
import DeptSelector from '@/components/DeptSelect/WithLabel.vue'
import { useSubmitLock } from '@/utils/useUtils'

// 编辑的节点
const editNode = ref(null)
// 弹窗的显示
const visible = ref(false)
const emits = defineEmits(['refresh'])
const ruleFormRef = ref(null)
const ruleForm = reactive({
  name: '',
  pid: '',
})
const rules = {
  name: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
  pid: [{ required: true, message: '请选择所属部门', trigger: 'change' }],
}

const isSubDept = ref(false)

const { loading: submitLoading, run } = useSubmitLock()
const isEditNode = computed(() => editNode.value && !isSubDept.value)
const title = computed(() => {
  if (isSubDept.value) return '添加子部门'
  return editNode.value ? '编辑部门' : '新增部门'
})

// 打开弹窗 isSub 是否为子部门
const openModal = (node, isSub = false) => {
  editNode.value = node
  isSubDept.value = isSub
  if (node) {
    ruleForm.name = isSub ? '' : node?.data?.label
    ruleForm.pid = isSub ? `${node?.data?.id}` : `${node?.data?.pid}`
  }
  visible.value = true
}

// 通过两个值需要判断出 是新增还是编辑 编辑子部门
const handleOpen = () => {
  ruleFormRef?.value?.clearValidate()
}
// 关闭弹窗
const handleClose = () => {
  ruleForm.name = ''
  ruleForm.pid = ''
  ruleFormRef.value?.clearValidate()
  visible.value = false
}

const handleSubmit = () => {
  ruleFormRef.value.validate((valid) => {
    if (!valid) return
    run(async () => {
      const params = { ...ruleForm }
      // 编辑
      const action = isEditNode.value ? editDept : addDept
      if (isEditNode.value) {
        params.id = editNode.value.data.id
      }
      const { code = null, data = null } = await action({ ...params })
      if (code === 1) {
        // 无论是编辑还是新增都需要传回 节点信息  编辑时 为 editNode.value 新增时 为 data
        emits(
          'refresh',
          isEditNode.value
            ? {
              ...editNode.value.data,
              pid: ruleForm.pid,
              label: ruleForm.name,
              name: ruleForm.name,
            }
            : {
              ...data,
              label: data.name,
              name: data.name,
            },
        )
        handleClose()
      }
    })
  })
}

defineExpose({
  open: openModal,
  close: handleClose,
})
</script>

<style lang="scss" scoped>
::v-deep(.el-input__inner) {
  padding-right: 50px !important; /* 假设限制显示占据75px，加上一些边距缓解重叠 */
  padding-left: 10px; /* 适当的左侧内边距 */
}
::v-deep(.el-select--small) {
  width: 100% !important;
}
::v-deep(.el-dialog) {
  border-radius: 12px;
}
::v-deep(.el-dialog__header) {
  border: 0 none;
}
::v-deep(.el-dialog__body) {
  display: flex;
  flex-direction: column;
  padding: 16px 32px;
  gap: 24px;
  align-self: stretch;
}
::v-deep(.el-dialog__title) {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  letter-spacing: 0em;
  /* 信息/font-black1 */
  /* 样式描述：强调信息 */
  color: rgba(0, 0, 0, 0.9);
}
</style>
